import { render, staticRenderFns } from "./departmentInfo.vue?vue&type=template&id=0347615e&"
import script from "./departmentInfo.vue?vue&type=script&lang=js&"
export * from "./departmentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports